import { api } from '../client'
import type { RequestOptions } from '../client'
import type { NotificationConfig, NotificationLogEntry } from './types'

export const notificationsHttpApi = {
  getConfig: (options?: RequestOptions): Promise<NotificationConfig> =>
    api.get<NotificationConfig>('/notifications/config', options),

  updateConfig: (patch: Partial<NotificationConfig>): Promise<NotificationConfig> =>
    api.patch<NotificationConfig>('/notifications/config', patch),

  log: (options?: RequestOptions): Promise<NotificationLogEntry[]> =>
    api.get<NotificationLogEntry[]>('/notifications/log', options),
}
